/* ============================================================================
   KOTT Lab — Scroll-cue pill
   ----------------------------------------------------------------------------
   A small "גלילה למטה" pill that fades in above the existing scroll-chevron
   cue ~1s after the intro loader lifts, on the home hero, the story hero and
   the projects reel. It lives INSIDE each hero's cue wrapper, so it inherits
   the cue's scroll-driven fade — i.e. it disappears the moment the visitor
   starts scrolling (exactly when the hint is no longer needed).

   On the home hero the service chips under the title aren't links; some
   visitors click them expecting navigation. Any [data-scroll-pill-trigger]
   click re-reveals + pulses the pill in the same section, pointing them at
   what to actually do instead of leaving the site.

   Loaded (deferred) by each of those three sections; guarded to run once.
   ========================================================================== */
(function () {
  if (window.__kottScrollPill) return;
  window.__kottScrollPill = 1;

  const pills = [...document.querySelectorAll('.scroll-pill')];
  if (!pills.length) return;

  const reduced = window.kottReduceMotion
    ? window.kottReduceMotion()
    : matchMedia('(prefers-reduced-motion: reduce)').matches;

  const DELAY = reduced ? 0 : 1000; // appear ~1s after the visitor lands

  const reveal = () => pills.forEach((p) => p.classList.add('is-on'));

  let armed = false;
  function arm() {
    if (armed) return;
    armed = true;
    setTimeout(reveal, DELAY);
  }

  if (window.__kottLoaderDone) arm();
  else {
    document.addEventListener('kott:loader:done', arm, { once: true });
    setTimeout(arm, 2600); // fallback if no loader runs on this page
  }

  // Chip / decorative-element clicks: surface the cue instead of dead-ending.
  document.querySelectorAll('[data-scroll-pill-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const scope = trigger.closest('section') || document;
      const pill = scope.querySelector('.scroll-pill');
      if (!pill) return;
      pill.classList.add('is-on');
      pill.classList.remove('is-pulse');
      void pill.offsetWidth; // restart the pulse animation
      pill.classList.add('is-pulse');
    });
  });
})();
